import styled from "styled-components";

const Container = styled.div`
  border-bottom: 1px solid #eeeeee;
  font-size: 16px;
  font-weight: 400;
  padding-bottom: 20px;
  padding-top: 10px;
  margin-bottom: 10px;
  display: block;
  &:last-child {
    border-bottom: none;
  }
  text-decoration: none;
  color: #383838;
`;

export default Container;
